export const filmsB = [
  {
    title: "A New Hope",
    episode_id: 4,
    opening_crawl:
      "It is a period of civil war.\r\nRebel spaceships, striking\r\nfrom a hidden base, have won\r\ntheir first victory against\r\nthe evil Galactic Empire.\r\n\r\nDuring the battle, Rebel\r\nspies managed to steal secret\r\nplans to the Empire's\r\nultimate weapon, the DEATH\r\nSTAR, an armored space\r\nstation with enough power\r\nto destroy an entire planet.\r\n\r\nPursued by the Empire's\r\nsinister agents, Princess\r\nLeia races home aboard her\r\nstarship, custodian of the\r\nstolen plans that can save her\r\npeople and restore\r\nfreedom to the galaxy....",
    director: "George Lucas",
    producer: "Gary Kurtz, Rick McCallum",
    release_date: "1977-05-25",
    characters: [
      "https://swapi.dev/api/people/1/",
      "https://swapi.dev/api/people/2/",
      "https://swapi.dev/api/people/3/",
      "https://swapi.dev/api/people/4/",
      "https://swapi.dev/api/people/5/",
      "https://swapi.dev/api/people/6/",
      "https://swapi.dev/api/people/7/",
      "https://swapi.dev/api/people/8/",
      "https://swapi.dev/api/people/9/",
      "https://swapi.dev/api/people/10/",
      "https://swapi.dev/api/people/12/",
      "https://swapi.dev/api/people/13/",
      "https://swapi.dev/api/people/14/",
      "https://swapi.dev/api/people/15/",
      "https://swapi.dev/api/people/16/",
      "https://swapi.dev/api/people/18/",
      "https://swapi.dev/api/people/19/",
      "https://swapi.dev/api/people/81/",
    ],
    planets: [
      "https://swapi.dev/api/planets/1/",
      "https://swapi.dev/api/planets/2/",
      "https://swapi.dev/api/planets/3/",
    ],
    starships: [
      "https://swapi.dev/api/starships/2/",
      "https://swapi.dev/api/starships/3/",
      "https://swapi.dev/api/starships/5/",
      "https://swapi.dev/api/starships/9/",
      "https://swapi.dev/api/starships/10/",
      "https://swapi.dev/api/starships/11/",
      "https://swapi.dev/api/starships/12/",
      "https://swapi.dev/api/starships/13/",
    ],
    vehicles: [
      "https://swapi.dev/api/vehicles/4/",
      "https://swapi.dev/api/vehicles/6/",
      "https://swapi.dev/api/vehicles/7/",
      "https://swapi.dev/api/vehicles/8/",
    ],
    species: [
      "https://swapi.dev/api/species/1/",
      "https://swapi.dev/api/species/2/",
      "https://swapi.dev/api/species/3/",
      "https://swapi.dev/api/species/4/",
      "https://swapi.dev/api/species/5/",
    ],
    created: "2014-12-10T14:23:31.880000Z",
    edited: "2014-12-20T19:49:45.256000Z",
    url: "https://swapi.dev/api/films/1/",
  },
  {
    title: "The Empire Strikes Back",
    episode_id: 5,
    opening_crawl:
      "It is a dark time for the\r\nRebellion. Although the Death\r\nStar has been destroyed,\r\nImperial troops have driven the\r\nRebel forces from their hidden\r\nbase and pursued them across\r\nthe galaxy.\r\n\r\nEvading the dreaded Imperial\r\nStarfleet, a group of freedom\r\nfighters led by Luke Skywalker\r\nhas established a new secret\r\nbase on the remote ice world\r\nof Hoth.\r\n\r\nThe evil lord Darth Vader,\r\nobsessed with finding young\r\nSkywalker, has dispatched\r\nthousands of remote probes into\r\nthe far reaches of space....",
    director: "Irvin Kershner",
    producer: "Gary Kurtz, Rick McCallum",
    release_date: "1980-05-17",
    characters: [
      "https://swapi.dev/api/people/1/",
      "https://swapi.dev/api/people/2/",
      "https://swapi.dev/api/people/3/",
      "https://swapi.dev/api/people/4/",
      "https://swapi.dev/api/people/5/",
      "https://swapi.dev/api/people/10/",
      "https://swapi.dev/api/people/13/",
      "https://swapi.dev/api/people/14/",
      "https://swapi.dev/api/people/18/",
      "https://swapi.dev/api/people/20/",
      "https://swapi.dev/api/people/21/",
      "https://swapi.dev/api/people/22/",
      "https://swapi.dev/api/people/23/",
      "https://swapi.dev/api/people/24/",
      "https://swapi.dev/api/people/25/",
      "https://swapi.dev/api/people/26/",
    ],
    planets: [
      "https://swapi.dev/api/planets/4/",
      "https://swapi.dev/api/planets/5/",
      "https://swapi.dev/api/planets/6/",
      "https://swapi.dev/api/planets/27/",
    ],
    starships: [
      "https://swapi.dev/api/starships/3/",
      "https://swapi.dev/api/starships/10/",
      "https://swapi.dev/api/starships/11/",
      "https://swapi.dev/api/starships/12/",
      "https://swapi.dev/api/starships/15/",
      "https://swapi.dev/api/starships/17/",
      "https://swapi.dev/api/starships/21/",
      "https://swapi.dev/api/starships/22/",
      "https://swapi.dev/api/starships/23/",
    ],
    vehicles: [
      "https://swapi.dev/api/vehicles/8/",
      "https://swapi.dev/api/vehicles/14/",
      "https://swapi.dev/api/vehicles/16/",
      "https://swapi.dev/api/vehicles/18/",
      "https://swapi.dev/api/vehicles/19/",
      "https://swapi.dev/api/vehicles/20/",
    ],
    species: [
      "https://swapi.dev/api/species/1/",
      "https://swapi.dev/api/species/2/",
      "https://swapi.dev/api/species/3/",
      "https://swapi.dev/api/species/6/",
      "https://swapi.dev/api/species/7/",
    ],
    created: "2014-12-12T11:26:24.656000Z",
    edited: "2014-12-15T13:07:53.386000Z",
    url: "https://swapi.dev/api/films/2/",
  },
  {
    title: "Return of the Jedi",
    episode_id: 6,
    opening_crawl:
      "Luke Skywalker has returned to\r\nhis home planet of Tatooine in\r\nan attempt to rescue his\r\nfriend Han Solo from the\r\nclutches of the vile gangster\r\nJabba the Hutt.\r\n\r\nLittle does Luke know that the\r\nGALACTIC EMPIRE has secretly\r\nbegun construction on a new\r\narmored space station even\r\nmore powerful than the first\r\ndreaded Death Star.\r\n\r\nWhen completed, this ultimate\r\nweapon will spell certain doom\r\nfor the small band of rebels\r\nstruggling to restore freedom\r\nto the galaxy...",
    director: "Richard Marquand",
    producer: "Howard G. Kazanjian, George Lucas, Rick McCallum",
    release_date: "1983-05-25",
    characters: [
      "https://swapi.dev/api/people/1/",
      "https://swapi.dev/api/people/2/",
      "https://swapi.dev/api/people/3/",
      "https://swapi.dev/api/people/4/",
      "https://swapi.dev/api/people/5/",
      "https://swapi.dev/api/people/10/",
      "https://swapi.dev/api/people/13/",
      "https://swapi.dev/api/people/14/",
      "https://swapi.dev/api/people/16/",
      "https://swapi.dev/api/people/18/",
      "https://swapi.dev/api/people/20/",
      "https://swapi.dev/api/people/21/",
      "https://swapi.dev/api/people/22/",
      "https://swapi.dev/api/people/25/",
      "https://swapi.dev/api/people/27/",
      "https://swapi.dev/api/people/28/",
      "https://swapi.dev/api/people/29/",
      "https://swapi.dev/api/people/30/",
      "https://swapi.dev/api/people/31/",
      "https://swapi.dev/api/people/45/",
    ],
    planets: [
      "https://swapi.dev/api/planets/1/",
      "https://swapi.dev/api/planets/5/",
      "https://swapi.dev/api/planets/7/",
      "https://swapi.dev/api/planets/8/",
      "https://swapi.dev/api/planets/9/",
    ],
    starships: [
      "https://swapi.dev/api/starships/2/",
      "https://swapi.dev/api/starships/3/",
      "https://swapi.dev/api/starships/10/",
      "https://swapi.dev/api/starships/11/",
      "https://swapi.dev/api/starships/12/",
      "https://swapi.dev/api/starships/15/",
      "https://swapi.dev/api/starships/17/",
      "https://swapi.dev/api/starships/22/",
      "https://swapi.dev/api/starships/23/",
      "https://swapi.dev/api/starships/27/",
      "https://swapi.dev/api/starships/28/",
      "https://swapi.dev/api/starships/29/",
    ],
    vehicles: [
      "https://swapi.dev/api/vehicles/8/",
      "https://swapi.dev/api/vehicles/16/",
      "https://swapi.dev/api/vehicles/18/",
      "https://swapi.dev/api/vehicles/19/",
      "https://swapi.dev/api/vehicles/24/",
      "https://swapi.dev/api/vehicles/25/",
      "https://swapi.dev/api/vehicles/26/",
      "https://swapi.dev/api/vehicles/30/",
    ],
    species: [
      "https://swapi.dev/api/species/1/",
      "https://swapi.dev/api/species/2/",
      "https://swapi.dev/api/species/3/",
      "https://swapi.dev/api/species/5/",
      "https://swapi.dev/api/species/6/",
      "https://swapi.dev/api/species/8/",
      "https://swapi.dev/api/species/9/",
      "https://swapi.dev/api/species/10/",
      "https://swapi.dev/api/species/15/",
    ],
    created: "2014-12-18T10:39:33.255000Z",
    edited: "2014-12-20T09:48:37.462000Z",
    url: "https://swapi.dev/api/films/3/",
  },
  {
    title: "The Phantom Menace",
    episode_id: 1,
    opening_crawl:
      "Turmoil has engulfed the\r\nGalactic Republic. The taxation\r\nof trade routes to outlying star\r\nsystems is in dispute.\r\n\r\nHoping to resolve the matter\r\nwith a blockade of deadly\r\nbattleships, the greedy Trade\r\nFederation has stopped all\r\nshipping to the small planet\r\nof Naboo.\r\n\r\nWhile the Congress of the\r\nRepublic endlessly debates\r\nthis alarming chain of events,\r\nthe Supreme Chancellor has\r\nsecretly dispatched two Jedi\r\nKnights, the guardians of\r\npeace and justice in the\r\ngalaxy, to settle the conflict....",
    director: "George Lucas",
    producer: "Rick McCallum",
    release_date: "1999-05-19",
    characters: [
      "https://swapi.dev/api/people/2/",
      "https://swapi.dev/api/people/3/",
      "https://swapi.dev/api/people/10/",
      "https://swapi.dev/api/people/11/",
      "https://swapi.dev/api/people/16/",
      "https://swapi.dev/api/people/20/",
      "https://swapi.dev/api/people/21/",
      "https://swapi.dev/api/people/32/",
      "https://swapi.dev/api/people/33/",
      "https://swapi.dev/api/people/34/",
      "https://swapi.dev/api/people/35/",
      "https://swapi.dev/api/people/36/",
      "https://swapi.dev/api/people/37/",
      "https://swapi.dev/api/people/38/",
      "https://swapi.dev/api/people/39/",
      "https://swapi.dev/api/people/40/",
      "https://swapi.dev/api/people/41/",
      "https://swapi.dev/api/people/42/",
      "https://swapi.dev/api/people/43/",
      "https://swapi.dev/api/people/44/",
      "https://swapi.dev/api/people/46/",
      "https://swapi.dev/api/people/47/",
      "https://swapi.dev/api/people/48/",
      "https://swapi.dev/api/people/49/",
      "https://swapi.dev/api/people/50/",
      "https://swapi.dev/api/people/51/",
      "https://swapi.dev/api/people/52/",
      "https://swapi.dev/api/people/53/",
      "https://swapi.dev/api/people/54/",
      "https://swapi.dev/api/people/55/",
      "https://swapi.dev/api/people/56/",
      "https://swapi.dev/api/people/57/",
      "https://swapi.dev/api/people/58/",
      "https://swapi.dev/api/people/59/",
    ],
    planets: [
      "https://swapi.dev/api/planets/1/",
      "https://swapi.dev/api/planets/8/",
      "https://swapi.dev/api/planets/9/",
    ],
    starships: [
      "https://swapi.dev/api/starships/31/",
      "https://swapi.dev/api/starships/32/",
      "https://swapi.dev/api/starships/39/",
      "https://swapi.dev/api/starships/40/",
      "https://swapi.dev/api/starships/41/",
    ],
    vehicles: [
      "https://swapi.dev/api/vehicles/33/",
      "https://swapi.dev/api/vehicles/34/",
      "https://swapi.dev/api/vehicles/35/",
      "https://swapi.dev/api/vehicles/36/",
      "https://swapi.dev/api/vehicles/37/",
      "https://swapi.dev/api/vehicles/38/",
      "https://swapi.dev/api/vehicles/42/",
    ],
    species: [
      "https://swapi.dev/api/species/1/",
      "https://swapi.dev/api/species/2/",
      "https://swapi.dev/api/species/6/",
      "https://swapi.dev/api/species/11/",
      "https://swapi.dev/api/species/12/",
      "https://swapi.dev/api/species/13/",
      "https://swapi.dev/api/species/14/",
      "https://swapi.dev/api/species/15/",
      "https://swapi.dev/api/species/16/",
      "https://swapi.dev/api/species/17/",
      "https://swapi.dev/api/species/18/",
      "https://swapi.dev/api/species/19/",
      "https://swapi.dev/api/species/20/",
      "https://swapi.dev/api/species/21/",
      "https://swapi.dev/api/species/22/",
      "https://swapi.dev/api/species/23/",
      "https://swapi.dev/api/species/24/",
      "https://swapi.dev/api/species/25/",
      "https://swapi.dev/api/species/26/",
      "https://swapi.dev/api/species/27/",
    ],
    created: "2014-12-19T16:52:55.740000Z",
    edited: "2014-12-20T10:54:07.216000Z",
    url: "https://swapi.dev/api/films/4/",
  },
  {
    title: "Attack of the Clones",
    episode_id: 2,
    opening_crawl:
      "There is unrest in the Galactic\r\nSenate. Several thousand solar\r\nsystems have declared their\r\nintentions to leave the Republic.\r\n\r\nThis separatist movement,\r\nunder the leadership of the\r\nmysterious Count Dooku, has\r\nmade it difficult for the limited\r\nnumber of Jedi Knights to maintain \r\npeace and order in the galaxy.\r\n\r\nSenator Amidala, the former\r\nQueen of Naboo, is returning\r\nto the Galactic Senate to vote\r\non the critical issue of creating\r\nan ARMY OF THE REPUBLIC\r\nto assist the overwhelmed\r\nJedi....",
    director: "George Lucas",
    producer: "Rick McCallum",
    release_date: "2002-05-16",
    characters: [
      "https://swapi.dev/api/people/2/",
      "https://swapi.dev/api/people/3/",
      "https://swapi.dev/api/people/6/",
      "https://swapi.dev/api/people/7/",
      "https://swapi.dev/api/people/10/",
      "https://swapi.dev/api/people/11/",
      "https://swapi.dev/api/people/20/",
      "https://swapi.dev/api/people/21/",
      "https://swapi.dev/api/people/22/",
      "https://swapi.dev/api/people/33/",
      "https://swapi.dev/api/people/35/",
      "https://swapi.dev/api/people/36/",
      "https://swapi.dev/api/people/40/",
      "https://swapi.dev/api/people/43/",
      "https://swapi.dev/api/people/46/",
      "https://swapi.dev/api/people/51/",
      "https://swapi.dev/api/people/52/",
      "https://swapi.dev/api/people/53/",
      "https://swapi.dev/api/people/58/",
      "https://swapi.dev/api/people/59/",
      "https://swapi.dev/api/people/60/",
      "https://swapi.dev/api/people/61/",
      "https://swapi.dev/api/people/62/",
      "https://swapi.dev/api/people/63/",
      "https://swapi.dev/api/people/64/",
      "https://swapi.dev/api/people/65/",
      "https://swapi.dev/api/people/66/",
      "https://swapi.dev/api/people/67/",
      "https://swapi.dev/api/people/68/",
      "https://swapi.dev/api/people/69/",
      "https://swapi.dev/api/people/70/",
      "https://swapi.dev/api/people/71/",
      "https://swapi.dev/api/people/72/",
      "https://swapi.dev/api/people/73/",
      "https://swapi.dev/api/people/74/",
      "https://swapi.dev/api/people/75/",
      "https://swapi.dev/api/people/76/",
      "https://swapi.dev/api/people/77/",
      "https://swapi.dev/api/people/78/",
      "https://swapi.dev/api/people/82/",
    ],
    planets: [
      "https://swapi.dev/api/planets/1/",
      "https://swapi.dev/api/planets/8/",
      "https://swapi.dev/api/planets/9/",
      "https://swapi.dev/api/planets/10/",
      "https://swapi.dev/api/planets/11/",
    ],
    starships: [
      "https://swapi.dev/api/starships/21/",
      "https://swapi.dev/api/starships/32/",
      "https://swapi.dev/api/starships/39/",
      "https://swapi.dev/api/starships/43/",
      "https://swapi.dev/api/starships/47/",
      "https://swapi.dev/api/starships/48/",
      "https://swapi.dev/api/starships/49/",
      "https://swapi.dev/api/starships/52/",
      "https://swapi.dev/api/starships/58/",
    ],
    vehicles: [
      "https://swapi.dev/api/vehicles/4/",
      "https://swapi.dev/api/vehicles/44/",
      "https://swapi.dev/api/vehicles/45/",
      "https://swapi.dev/api/vehicles/46/",
      "https://swapi.dev/api/vehicles/50/",
      "https://swapi.dev/api/vehicles/51/",
      "https://swapi.dev/api/vehicles/53/",
      "https://swapi.dev/api/vehicles/54/",
      "https://swapi.dev/api/vehicles/55/",
      "https://swapi.dev/api/vehicles/56/",
      "https://swapi.dev/api/vehicles/57/",
    ],
    species: [
      "https://swapi.dev/api/species/1/",
      "https://swapi.dev/api/species/2/",
      "https://swapi.dev/api/species/6/",
      "https://swapi.dev/api/species/12/",
      "https://swapi.dev/api/species/13/",
      "https://swapi.dev/api/species/15/",
      "https://swapi.dev/api/species/28/",
      "https://swapi.dev/api/species/29/",
      "https://swapi.dev/api/species/30/",
      "https://swapi.dev/api/species/31/",
      "https://swapi.dev/api/species/32/",
      "https://swapi.dev/api/species/33/",
      "https://swapi.dev/api/species/34/",
      "https://swapi.dev/api/species/35/",
    ],
    created: "2014-12-20T10:57:57.886000Z",
    edited: "2014-12-20T20:18:48.516000Z",
    url: "https://swapi.dev/api/films/5/",
  },
  {
    title: "Revenge of the Sith",
    episode_id: 3,
    opening_crawl:
      "War! The Republic is crumbling\r\nunder attacks by the ruthless\r\nSith Lord, Count Dooku.\r\nThere are heroes on both sides.\r\nEvil is everywhere.\r\n\r\nIn a stunning move, the\r\nfiendish droid leader, General\r\nGrievous, has swept into the\r\nRepublic capital and kidnapped\r\nChancellor Palpatine, leader of\r\nthe Galactic Senate.\r\n\r\nAs the Separatist Droid Army\r\nattempts to flee the besieged\r\ncapital with their valuable\r\nhostage, two Jedi Knights lead a\r\ndesperate mission to rescue the\r\ncaptive Chancellor....",
    director: "George Lucas",
    producer: "Rick McCallum",
    release_date: "2005-05-19",
    characters: [
      "https://swapi.dev/api/people/1/",
      "https://swapi.dev/api/people/2/",
      "https://swapi.dev/api/people/3/",
      "https://swapi.dev/api/people/4/",
      "https://swapi.dev/api/people/5/",
      "https://swapi.dev/api/people/6/",
      "https://swapi.dev/api/people/7/",
      "https://swapi.dev/api/people/10/",
      "https://swapi.dev/api/people/11/",
      "https://swapi.dev/api/people/12/",
      "https://swapi.dev/api/people/13/",
      "https://swapi.dev/api/people/20/",
      "https://swapi.dev/api/people/21/",
      "https://swapi.dev/api/people/33/",
      "https://swapi.dev/api/people/35/",
      "https://swapi.dev/api/people/46/",
      "https://swapi.dev/api/people/51/",
      "https://swapi.dev/api/people/52/",
      "https://swapi.dev/api/people/53/",
      "https://swapi.dev/api/people/54/",
      "https://swapi.dev/api/people/55/",
      "https://swapi.dev/api/people/56/",
      "https://swapi.dev/api/people/58/",
      "https://swapi.dev/api/people/63/",
      "https://swapi.dev/api/people/64/",
      "https://swapi.dev/api/people/67/",
      "https://swapi.dev/api/people/68/",
      "https://swapi.dev/api/people/75/",
      "https://swapi.dev/api/people/78/",
      "https://swapi.dev/api/people/79/",
      "https://swapi.dev/api/people/80/",
      "https://swapi.dev/api/people/81/",
      "https://swapi.dev/api/people/82/",
      "https://swapi.dev/api/people/83/",
    ],
    planets: [
      "https://swapi.dev/api/planets/1/",
      "https://swapi.dev/api/planets/2/",
      "https://swapi.dev/api/planets/5/",
      "https://swapi.dev/api/planets/8/",
      "https://swapi.dev/api/planets/9/",
      "https://swapi.dev/api/planets/12/",
      "https://swapi.dev/api/planets/13/",
      "https://swapi.dev/api/planets/14/",
      "https://swapi.dev/api/planets/15/",
      "https://swapi.dev/api/planets/16/",
      "https://swapi.dev/api/planets/17/",
      "https://swapi.dev/api/planets/18/",
      "https://swapi.dev/api/planets/19/",
    ],
    starships: [
      "https://swapi.dev/api/starships/2/",
      "https://swapi.dev/api/starships/32/",
      "https://swapi.dev/api/starships/48/",
      "https://swapi.dev/api/starships/59/",
      "https://swapi.dev/api/starships/61/",
      "https://swapi.dev/api/starships/63/",
      "https://swapi.dev/api/starships/64/",
      "https://swapi.dev/api/starships/65/",
      "https://swapi.dev/api/starships/66/",
      "https://swapi.dev/api/starships/68/",
      "https://swapi.dev/api/starships/74/",
      "https://swapi.dev/api/starships/75/",
    ],
    vehicles: [
      "https://swapi.dev/api/vehicles/33/",
      "https://swapi.dev/api/vehicles/50/",
      "https://swapi.dev/api/vehicles/53/",
      "https://swapi.dev/api/vehicles/56/",
      "https://swapi.dev/api/vehicles/60/",
      "https://swapi.dev/api/vehicles/62/",
      "https://swapi.dev/api/vehicles/67/",
      "https://swapi.dev/api/vehicles/69/",
      "https://swapi.dev/api/vehicles/70/",
      "https://swapi.dev/api/vehicles/71/",
      "https://swapi.dev/api/vehicles/72/",
      "https://swapi.dev/api/vehicles/73/",
      "https://swapi.dev/api/vehicles/76/",
    ],
    species: [
      "https://swapi.dev/api/species/1/",
      "https://swapi.dev/api/species/2/",
      "https://swapi.dev/api/species/3/",
      "https://swapi.dev/api/species/6/",
      "https://swapi.dev/api/species/15/",
      "https://swapi.dev/api/species/19/",
      "https://swapi.dev/api/species/20/",
      "https://swapi.dev/api/species/23/",
      "https://swapi.dev/api/species/24/",
      "https://swapi.dev/api/species/25/",
      "https://swapi.dev/api/species/26/",
      "https://swapi.dev/api/species/27/",
      "https://swapi.dev/api/species/28/",
      "https://swapi.dev/api/species/29/",
      "https://swapi.dev/api/species/30/",
      "https://swapi.dev/api/species/33/",
      "https://swapi.dev/api/species/34/",
      "https://swapi.dev/api/species/35/",
      "https://swapi.dev/api/species/36/",
      "https://swapi.dev/api/species/37/",
    ],
    created: "2014-12-20T18:49:38.403000Z",
    edited: "2014-12-20T20:47:52.073000Z",
    url: "https://swapi.dev/api/films/6/",
  },
];

export const starshipsB = [
  {
    name: "CR90 corvette",
    model: "CR90 corvette",
    manufacturer: "Corellian Engineering Corporation",
    cost_in_credits: "3500000",
    length: "150",
    max_atmosphering_speed: "950",
    crew: "30-165",
    passengers: "600",
    cargo_capacity: "3000000",
    consumables: "1 year",
    hyperdrive_rating: "2.0",
    MGLT: "60",
    starship_class: "corvette",
    pilots: [],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/6/",
    ],
    created: "2014-12-10T14:20:33.369000Z",
    edited: "2014-12-20T21:23:49.867000Z",
    url: "https://swapi.dev/api/starships/2/",
  },
  {
    name: "Star Destroyer",
    model: "Imperial I-class Star Destroyer",
    manufacturer: "Kuat Drive Yards",
    cost_in_credits: "150000000",
    length: "1,600",
    max_atmosphering_speed: "975",
    crew: "47,060",
    passengers: "n/a",
    cargo_capacity: "36000000",
    consumables: "2 years",
    hyperdrive_rating: "2.0",
    MGLT: "60",
    starship_class: "Star Destroyer",
    pilots: [],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
    ],
    created: "2014-12-10T15:08:19.848000Z",
    edited: "2014-12-20T21:23:49.870000Z",
    url: "https://swapi.dev/api/starships/3/",
  },
  {
    name: "Sentinel-class landing craft",
    model: "Sentinel-class landing craft",
    manufacturer: "Sienar Fleet Systems, Cyngus Spaceworks",
    cost_in_credits: "240000",
    length: "38",
    max_atmosphering_speed: "1000",
    crew: "5",
    passengers: "75",
    cargo_capacity: "180000",
    consumables: "1 month",
    hyperdrive_rating: "1.0",
    MGLT: "70",
    starship_class: "landing craft",
    pilots: [],
    films: ["https://swapi.dev/api/films/1/"],
    created: "2014-12-10T15:48:00.586000Z",
    edited: "2014-12-20T21:23:49.873000Z",
    url: "https://swapi.dev/api/starships/5/",
  },
  {
    name: "Death Star",
    model: "DS-1 Orbital Battle Station",
    manufacturer:
      "Imperial Department of Military Research, Sienar Fleet Systems",
    cost_in_credits: "1000000000000",
    length: "120000",
    max_atmosphering_speed: "n/a",
    crew: "342,953",
    passengers: "843,342",
    cargo_capacity: "1000000000000",
    consumables: "3 years",
    hyperdrive_rating: "4.0",
    MGLT: "10",
    starship_class: "Deep Space Mobile Battlestation",
    pilots: [],
    films: ["https://swapi.dev/api/films/1/"],
    created: "2014-12-10T16:36:50.509000Z",
    edited: "2014-12-20T21:26:24.783000Z",
    url: "https://swapi.dev/api/starships/9/",
  },
  {
    name: "Millennium Falcon",
    model: "YT-1300 light freighter",
    manufacturer: "Corellian Engineering Corporation",
    cost_in_credits: "100000",
    length: "34.37",
    max_atmosphering_speed: "1050",
    crew: "4",
    passengers: "6",
    cargo_capacity: "100000",
    consumables: "2 months",
    hyperdrive_rating: "0.5",
    MGLT: "75",
    starship_class: "Light freighter",
    pilots: [
      "https://swapi.dev/api/people/13/",
      "https://swapi.dev/api/people/14/",
      "https://swapi.dev/api/people/25/",
      "https://swapi.dev/api/people/31/",
    ],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
    ],
    created: "2014-12-10T16:59:45.094000Z",
    edited: "2014-12-20T21:23:49.880000Z",
    url: "https://swapi.dev/api/starships/10/",
  },
  {
    name: "Y-wing",
    model: "BTL Y-wing",
    manufacturer: "Koensayr Manufacturing",
    cost_in_credits: "134999",
    length: "14",
    max_atmosphering_speed: "1000km",
    crew: "2",
    passengers: "0",
    cargo_capacity: "110",
    consumables: "1 week",
    hyperdrive_rating: "1.0",
    MGLT: "80",
    starship_class: "assault starfighter",
    pilots: [],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
    ],
    created: "2014-12-12T11:00:39.817000Z",
    edited: "2014-12-20T21:23:49.883000Z",
    url: "https://swapi.dev/api/starships/11/",
  },
  {
    name: "X-wing",
    model: "T-65 X-wing",
    manufacturer: "Incom Corporation",
    cost_in_credits: "149999",
    length: "12.5",
    max_atmosphering_speed: "1050",
    crew: "1",
    passengers: "0",
    cargo_capacity: "110",
    consumables: "1 week",
    hyperdrive_rating: "1.0",
    MGLT: "100",
    starship_class: "Starfighter",
    pilots: [
      "https://swapi.dev/api/people/1/",
      "https://swapi.dev/api/people/9/",
      "https://swapi.dev/api/people/18/",
      "https://swapi.dev/api/people/19/",
    ],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
    ],
    created: "2014-12-12T11:19:05.340000Z",
    edited: "2014-12-20T21:23:49.886000Z",
    url: "https://swapi.dev/api/starships/12/",
  },
  {
    name: "TIE Advanced x1",
    model: "Twin Ion Engine Advanced x1",
    manufacturer: "Sienar Fleet Systems",
    cost_in_credits: "unknown",
    length: "9.2",
    max_atmosphering_speed: "1200",
    crew: "1",
    passengers: "0",
    cargo_capacity: "150",
    consumables: "5 days",
    hyperdrive_rating: "1.0",
    MGLT: "105",
    starship_class: "Starfighter",
    pilots: ["https://swapi.dev/api/people/4/"],
    films: ["https://swapi.dev/api/films/1/"],
    created: "2014-12-12T11:21:32.991000Z",
    edited: "2014-12-20T21:23:49.889000Z",
    url: "https://swapi.dev/api/starships/13/",
  },
  {
    name: "Executor",
    model: "Executor-class star dreadnought",
    manufacturer: "Kuat Drive Yards, Fondor Shipyards",
    cost_in_credits: "1143350000",
    length: "19000",
    max_atmosphering_speed: "n/a",
    crew: "279,144",
    passengers: "38000",
    cargo_capacity: "250000000",
    consumables: "6 years",
    hyperdrive_rating: "2.0",
    MGLT: "40",
    starship_class: "Star dreadnought",
    pilots: [],
    films: ["https://swapi.dev/api/films/2/", "https://swapi.dev/api/films/3/"],
    created: "2014-12-15T12:31:42.547000Z",
    edited: "2014-12-20T21:23:49.893000Z",
    url: "https://swapi.dev/api/starships/15/",
  },
  {
    name: "Rebel transport",
    model: "GR-75 medium transport",
    manufacturer: "Gallofree Yards, Inc.",
    cost_in_credits: "unknown",
    length: "90",
    max_atmosphering_speed: "650",
    crew: "6",
    passengers: "90",
    cargo_capacity: "19000000",
    consumables: "6 months",
    hyperdrive_rating: "4.0",
    MGLT: "20",
    starship_class: "Medium transport",
    pilots: [],
    films: ["https://swapi.dev/api/films/2/", "https://swapi.dev/api/films/3/"],
    created: "2014-12-15T12:34:52.264000Z",
    edited: "2014-12-20T21:23:49.895000Z",
    url: "https://swapi.dev/api/starships/17/",
  },
];
export const vehiclesB = [
  {
    name: "Sand Crawler",
    model: "Digger Crawler",
    manufacturer: "Corellia Mining Corporation",
    cost_in_credits: "150000",
    length: "36.8 ",
    max_atmosphering_speed: "30",
    crew: "46",
    passengers: "30",
    cargo_capacity: "50000",
    consumables: "2 months",
    vehicle_class: "wheeled",
    pilots: [],
    films: ["https://swapi.dev/api/films/1/", "https://swapi.dev/api/films/5/"],
    created: "2014-12-10T15:36:25.724000Z",
    edited: "2014-12-20T21:30:21.661000Z",
    url: "https://swapi.dev/api/vehicles/4/",
  },
  {
    name: "T-16 skyhopper",
    model: "T-16 skyhopper",
    manufacturer: "Incom Corporation",
    cost_in_credits: "14500",
    length: "10.4 ",
    max_atmosphering_speed: "1200",
    crew: "1",
    passengers: "1",
    cargo_capacity: "50",
    consumables: "0",
    vehicle_class: "repulsorcraft",
    pilots: [],
    films: ["https://swapi.dev/api/films/1/"],
    created: "2014-12-10T16:01:52.434000Z",
    edited: "2014-12-20T21:30:21.665000Z",
    url: "https://swapi.dev/api/vehicles/6/",
  },
  {
    name: "X-34 landspeeder",
    model: "X-34 landspeeder",
    manufacturer: "SoroSuub Corporation",
    cost_in_credits: "10550",
    length: "3.4 ",
    max_atmosphering_speed: "250",
    crew: "1",
    passengers: "1",
    cargo_capacity: "5",
    consumables: "unknown",
    vehicle_class: "repulsorcraft",
    pilots: [],
    films: ["https://swapi.dev/api/films/1/"],
    created: "2014-12-10T16:13:52.586000Z",
    edited: "2014-12-20T21:30:21.668000Z",
    url: "https://swapi.dev/api/vehicles/7/",
  },
  {
    name: "TIE/LN starfighter",
    model: "Twin Ion Engine/Ln Starfighter",
    manufacturer: "Sienar Fleet Systems",
    cost_in_credits: "unknown",
    length: "6.4",
    max_atmosphering_speed: "1200",
    crew: "1",
    passengers: "0",
    cargo_capacity: "65",
    consumables: "2 days",
    vehicle_class: "starfighter",
    pilots: [],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
    ],
    created: "2014-12-10T16:33:52.860000Z",
    edited: "2014-12-20T21:30:21.670000Z",
    url: "https://swapi.dev/api/vehicles/8/",
  },
  {
    name: "Snowspeeder",
    model: "t-47 airspeeder",
    manufacturer: "Incom corporation",
    cost_in_credits: "unknown",
    length: "4.5",
    max_atmosphering_speed: "650",
    crew: "2",
    passengers: "0",
    cargo_capacity: "10",
    consumables: "none",
    vehicle_class: "airspeeder",
    pilots: [
      "https://swapi.dev/api/people/1/",
      "https://swapi.dev/api/people/18/",
    ],
    films: ["https://swapi.dev/api/films/2/"],
    created: "2014-12-15T12:22:12Z",
    edited: "2014-12-20T21:30:21.672000Z",
    url: "https://swapi.dev/api/vehicles/14/",
  },
  {
    name: "TIE bomber",
    model: "TIE/sa bomber",
    manufacturer: "Sienar Fleet Systems",
    cost_in_credits: "unknown",
    length: "7.8",
    max_atmosphering_speed: "850",
    crew: "1",
    passengers: "0",
    cargo_capacity: "none",
    consumables: "2 days",
    vehicle_class: "space/planetary bomber",
    pilots: [],
    films: ["https://swapi.dev/api/films/2/", "https://swapi.dev/api/films/3/"],
    created: "2014-12-15T12:33:15.838000Z",
    edited: "2014-12-20T21:30:21.675000Z",
    url: "https://swapi.dev/api/vehicles/16/",
  },
  {
    name: "AT-AT",
    model: "All Terrain Armored Transport",
    manufacturer: "Kuat Drive Yards, Imperial Department of Military Research",
    cost_in_credits: "unknown",
    length: "20",
    max_atmosphering_speed: "60",
    crew: "5",
    passengers: "40",
    cargo_capacity: "1000",
    consumables: "unknown",
    vehicle_class: "assault walker",
    pilots: [],
    films: ["https://swapi.dev/api/films/2/", "https://swapi.dev/api/films/3/"],
    created: "2014-12-15T12:38:25.937000Z",
    edited: "2014-12-20T21:30:21.677000Z",
    url: "https://swapi.dev/api/vehicles/18/",
  },
  {
    name: "AT-ST",
    model: "All Terrain Scout Transport",
    manufacturer: "Kuat Drive Yards, Imperial Department of Military Research",
    cost_in_credits: "unknown",
    length: "2",
    max_atmosphering_speed: "90",
    crew: "2",
    passengers: "0",
    cargo_capacity: "200",
    consumables: "none",
    vehicle_class: "walker",
    pilots: ["https://swapi.dev/api/people/13/"],
    films: ["https://swapi.dev/api/films/2/", "https://swapi.dev/api/films/3/"],
    created: "2014-12-15T12:46:42.384000Z",
    edited: "2014-12-20T21:30:21.679000Z",
    url: "https://swapi.dev/api/vehicles/19/",
  },
  {
    name: "Storm IV Twin-Pod cloud car",
    model: "Storm IV Twin-Pod",
    manufacturer: "Bespin Motors",
    cost_in_credits: "75000",
    length: "7",
    max_atmosphering_speed: "1500",
    crew: "2",
    passengers: "0",
    cargo_capacity: "10",
    consumables: "1 day",
    vehicle_class: "repulsorcraft",
    pilots: [],
    films: ["https://swapi.dev/api/films/2/"],
    created: "2014-12-15T12:58:50.530000Z",
    edited: "2014-12-20T21:30:21.681000Z",
    url: "https://swapi.dev/api/vehicles/20/",
  },
  {
    name: "Sail barge",
    model: "Modified Luxury Sail Barge",
    manufacturer: "Ubrikkian Industries Custom Vehicle Division",
    cost_in_credits: "285000",
    length: "30",
    max_atmosphering_speed: "100",
    crew: "26",
    passengers: "500",
    cargo_capacity: "2000000",
    consumables: "Live food tanks",
    vehicle_class: "sail barge",
    pilots: [],
    films: ["https://swapi.dev/api/films/3/"],
    created: "2014-12-18T10:44:14.217000Z",
    edited: "2014-12-20T21:30:21.684000Z",
    url: "https://swapi.dev/api/vehicles/24/",
  },
];
export const peopleB = [
  {
    name: "Luke Skywalker",
    height: "172",
    mass: "77",
    hair_color: "blond",
    skin_color: "fair",
    eye_color: "blue",
    birth_year: "19BBY",
    gender: "male",
    homeworld: "https://swapi.dev/api/planets/1/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/6/",
    ],
    species: [],
    vehicles: [
      "https://swapi.dev/api/vehicles/14/",
      "https://swapi.dev/api/vehicles/30/",
    ],
    starships: [
      "https://swapi.dev/api/starships/12/",
      "https://swapi.dev/api/starships/22/",
    ],
    created: "2014-12-09T13:50:51.644000Z",
    edited: "2014-12-20T21:17:56.891000Z",
    url: "https://swapi.dev/api/people/1/",
  },
  {
    name: "C-3PO",
    height: "167",
    mass: "75",
    hair_color: "n/a",
    skin_color: "gold",
    eye_color: "yellow",
    birth_year: "112BBY",
    gender: "n/a",
    homeworld: "https://swapi.dev/api/planets/1/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/4/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    species: ["https://swapi.dev/api/species/2/"],
    vehicles: [],
    starships: [],
    created: "2014-12-10T15:10:51.357000Z",
    edited: "2014-12-20T21:17:50.309000Z",
    url: "https://swapi.dev/api/people/2/",
  },
  {
    name: "R2-D2",
    height: "96",
    mass: "32",
    hair_color: "n/a",
    skin_color: "white, blue",
    eye_color: "red",
    birth_year: "33BBY",
    gender: "n/a",
    homeworld: "https://swapi.dev/api/planets/8/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/4/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    species: ["https://swapi.dev/api/species/2/"],
    vehicles: [],
    starships: [],
    created: "2014-12-10T15:11:50.376000Z",
    edited: "2014-12-20T21:17:50.311000Z",
    url: "https://swapi.dev/api/people/3/",
  },
  {
    name: "Darth Vader",
    height: "202",
    mass: "136",
    hair_color: "none",
    skin_color: "white",
    eye_color: "yellow",
    birth_year: "41.9BBY",
    gender: "male",
    homeworld: "https://swapi.dev/api/planets/1/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/6/",
    ],
    species: [],
    vehicles: [],
    starships: ["https://swapi.dev/api/starships/13/"],
    created: "2014-12-10T15:18:20.704000Z",
    edited: "2014-12-20T21:17:50.313000Z",
    url: "https://swapi.dev/api/people/4/",
  },
  {
    name: "Leia Organa",
    height: "150",
    mass: "49",
    hair_color: "brown",
    skin_color: "light",
    eye_color: "brown",
    birth_year: "19BBY",
    gender: "female",
    homeworld: "https://swapi.dev/api/planets/2/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/6/",
    ],
    species: [],
    vehicles: ["https://swapi.dev/api/vehicles/30/"],
    starships: [],
    created: "2014-12-10T15:20:09.791000Z",
    edited: "2014-12-20T21:17:50.315000Z",
    url: "https://swapi.dev/api/people/5/",
  },
  {
    name: "Owen Lars",
    height: "178",
    mass: "120",
    hair_color: "brown, grey",
    skin_color: "light",
    eye_color: "blue",
    birth_year: "52BBY",
    gender: "male",
    homeworld: "https://swapi.dev/api/planets/1/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    species: [],
    vehicles: [],
    starships: [],
    created: "2014-12-10T15:52:14.024000Z",
    edited: "2014-12-20T21:17:50.317000Z",
    url: "https://swapi.dev/api/people/6/",
  },
  {
    name: "Beru Whitesun lars",
    height: "165",
    mass: "75",
    hair_color: "brown",
    skin_color: "light",
    eye_color: "blue",
    birth_year: "47BBY",
    gender: "female",
    homeworld: "https://swapi.dev/api/planets/1/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    species: [],
    vehicles: [],
    starships: [],
    created: "2014-12-10T15:53:41.121000Z",
    edited: "2014-12-20T21:17:50.319000Z",
    url: "https://swapi.dev/api/people/7/",
  },
  {
    name: "R5-D4",
    height: "97",
    mass: "32",
    hair_color: "n/a",
    skin_color: "white, red",
    eye_color: "red",
    birth_year: "unknown",
    gender: "n/a",
    homeworld: "https://swapi.dev/api/planets/1/",
    films: ["https://swapi.dev/api/films/1/"],
    species: ["https://swapi.dev/api/species/2/"],
    vehicles: [],
    starships: [],
    created: "2014-12-10T15:57:50.959000Z",
    edited: "2014-12-20T21:17:50.321000Z",
    url: "https://swapi.dev/api/people/8/",
  },
  {
    name: "Biggs Darklighter",
    height: "183",
    mass: "84",
    hair_color: "black",
    skin_color: "light",
    eye_color: "brown",
    birth_year: "24BBY",
    gender: "male",
    homeworld: "https://swapi.dev/api/planets/1/",
    films: ["https://swapi.dev/api/films/1/"],
    species: [],
    vehicles: [],
    starships: ["https://swapi.dev/api/starships/12/"],
    created: "2014-12-10T15:59:50.509000Z",
    edited: "2014-12-20T21:17:50.323000Z",
    url: "https://swapi.dev/api/people/9/",
  },
  {
    name: "Obi-Wan Kenobi",
    height: "182",
    mass: "77",
    hair_color: "auburn, white",
    skin_color: "fair",
    eye_color: "blue-gray",
    birth_year: "57BBY",
    gender: "male",
    homeworld: "https://swapi.dev/api/planets/20/",
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/4/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    species: [],
    vehicles: ["https://swapi.dev/api/vehicles/38/"],
    starships: [
      "https://swapi.dev/api/starships/48/",
      "https://swapi.dev/api/starships/59/",
      "https://swapi.dev/api/starships/64/",
      "https://swapi.dev/api/starships/65/",
      "https://swapi.dev/api/starships/74/",
    ],
    created: "2014-12-10T16:16:29.192000Z",
    edited: "2014-12-20T21:17:50.325000Z",
    url: "https://swapi.dev/api/people/10/",
  },
];
export const speciesB = [
  {
    name: "Human",
    classification: "mammal",
    designation: "sentient",
    average_height: "180",
    skin_colors: "caucasian, black, asian, hispanic",
    hair_colors: "blonde, brown, black, red",
    eye_colors: "brown, blue, green, hazel, grey, amber",
    average_lifespan: "120",
    homeworld: "https://swapi.dev/api/planets/9/",
    language: "Galactic Basic",
    people: [
      "https://swapi.dev/api/people/66/",
      "https://swapi.dev/api/people/67/",
      "https://swapi.dev/api/people/68/",
      "https://swapi.dev/api/people/74/",
    ],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/4/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    created: "2014-12-10T13:52:11.567000Z",
    edited: "2014-12-20T21:36:42.136000Z",
    url: "https://swapi.dev/api/species/1/",
  },
  {
    name: "Droid",
    classification: "artificial",
    designation: "sentient",
    average_height: "n/a",
    skin_colors: "n/a",
    hair_colors: "n/a",
    eye_colors: "n/a",
    average_lifespan: "indefinite",
    homeworld: null,
    language: "n/a",
    people: [
      "https://swapi.dev/api/people/2/",
      "https://swapi.dev/api/people/3/",
      "https://swapi.dev/api/people/8/",
      "https://swapi.dev/api/people/23/",
    ],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/4/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    created: "2014-12-10T15:16:16.259000Z",
    edited: "2014-12-20T21:36:42.139000Z",
    url: "https://swapi.dev/api/species/2/",
  },
  {
    name: "Wookie",
    classification: "mammal",
    designation: "sentient",
    average_height: "210",
    skin_colors: "gray",
    hair_colors: "black, brown",
    eye_colors: "blue, green, yellow, brown, golden, red",
    average_lifespan: "400",
    homeworld: "https://swapi.dev/api/planets/14/",
    language: "Shyriiwook",
    people: [
      "https://swapi.dev/api/people/13/",
      "https://swapi.dev/api/people/80/",
    ],
    films: [
      "https://swapi.dev/api/films/1/",
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/6/",
    ],
    created: "2014-12-10T16:44:31.486000Z",
    edited: "2014-12-20T21:36:42.142000Z",
    url: "https://swapi.dev/api/species/3/",
  },
  {
    name: "Rodian",
    classification: "sentient",
    designation: "reptilian",
    average_height: "170",
    skin_colors: "green, blue",
    hair_colors: "n/a",
    eye_colors: "black",
    average_lifespan: "unknown",
    homeworld: "https://swapi.dev/api/planets/23/",
    language: "Galatic Basic",
    people: ["https://swapi.dev/api/people/15/"],
    films: ["https://swapi.dev/api/films/1/"],
    created: "2014-12-10T17:05:26.471000Z",
    edited: "2014-12-20T21:36:42.144000Z",
    url: "https://swapi.dev/api/species/4/",
  },
  {
    name: "Hutt",
    classification: "gastropod",
    designation: "sentient",
    average_height: "300",
    skin_colors: "green, brown, tan",
    hair_colors: "n/a",
    eye_colors: "yellow, red",
    average_lifespan: "1000",
    homeworld: "https://swapi.dev/api/planets/24/",
    language: "Huttese",
    people: ["https://swapi.dev/api/people/16/"],
    films: ["https://swapi.dev/api/films/1/", "https://swapi.dev/api/films/3/"],
    created: "2014-12-10T17:12:50.410000Z",
    edited: "2014-12-20T21:36:42.146000Z",
    url: "https://swapi.dev/api/species/5/",
  },
  {
    name: "Yoda's species",
    classification: "mammal",
    designation: "sentient",
    average_height: "66",
    skin_colors: "green, yellow",
    hair_colors: "brown, white",
    eye_colors: "brown, green, yellow",
    average_lifespan: "900",
    homeworld: "https://swapi.dev/api/planets/28/",
    language: "Galactic basic",
    people: ["https://swapi.dev/api/people/20/"],
    films: [
      "https://swapi.dev/api/films/2/",
      "https://swapi.dev/api/films/3/",
      "https://swapi.dev/api/films/4/",
      "https://swapi.dev/api/films/5/",
      "https://swapi.dev/api/films/6/",
    ],
    created: "2014-12-15T12:27:22.877000Z",
    edited: "2014-12-20T21:36:42.148000Z",
    url: "https://swapi.dev/api/species/6/",
  },
  {
    name: "Trandoshan",
    classification: "reptile",
    designation: "sentient",
    average_height: "200",
    skin_colors: "brown, green",
    hair_colors: "none",
    eye_colors: "yellow, orange",
    average_lifespan: "unknown",
    homeworld: "https://swapi.dev/api/planets/29/",
    language: "Dosh",
    people: ["https://swapi.dev/api/people/24/"],
    films: ["https://swapi.dev/api/films/2/"],
    created: "2014-12-15T13:07:47.704000Z",
    edited: "2014-12-20T21:36:42.151000Z",
    url: "https://swapi.dev/api/species/7/",
  },
  {
    name: "Mon Calamari",
    classification: "amphibian",
    designation: "sentient",
    average_height: "160",
    skin_colors: "red, blue, brown, magenta",
    hair_colors: "none",
    eye_colors: "yellow",
    average_lifespan: "unknown",
    homeworld: "https://swapi.dev/api/planets/31/",
    language: "Mon Calamarian",
    people: ["https://swapi.dev/api/people/27/"],
    films: ["https://swapi.dev/api/films/3/"],
    created: "2014-12-18T11:09:52.263000Z",
    edited: "2014-12-20T21:36:42.153000Z",
    url: "https://swapi.dev/api/species/8/",
  },
  {
    name: "Ewok",
    classification: "mammal",
    designation: "sentient",
    average_height: "100",
    skin_colors: "brown",
    hair_colors: "white, brown, black",
    eye_colors: "orange, brown",
    average_lifespan: "unknown",
    homeworld: "https://swapi.dev/api/planets/7/",
    language: "Ewokese",
    people: ["https://swapi.dev/api/people/30/"],
    films: ["https://swapi.dev/api/films/3/"],
    created: "2014-12-18T11:22:00.285000Z",
    edited: "2014-12-20T21:36:42.155000Z",
    url: "https://swapi.dev/api/species/9/",
  },
  {
    name: "Sullustan",
    classification: "mammal",
    designation: "sentient",
    average_height: "180",
    skin_colors: "pale",
    hair_colors: "none",
    eye_colors: "black",
    average_lifespan: "unknown",
    homeworld: "https://swapi.dev/api/planets/33/",
    language: "Sullutese",
    people: ["https://swapi.dev/api/people/31/"],
    films: ["https://swapi.dev/api/films/3/"],
    created: "2014-12-18T11:26:20.103000Z",
    edited: "2014-12-20T21:36:42.157000Z",
    url: "https://swapi.dev/api/species/10/",
  },
];
